import { MetricUId } from "../../Metrics/constants"
import i18n from "../../../../utils/ChrI18n";
import getChartConfigTemplate from "../Templates/PieChart/utils"
import { mergeProps } from "../../../generic/Utils/mergeProps";

const metricColorMap = {
  [MetricUId.PENDING_PROGRAM_INVITATIONS]: "#FC8543",
  [MetricUId.ACCEPTED_PROGRAM_INVITATIONS]: "#0969DA",
  [MetricUId.EXPIRED_PROGRAM_INVITATIONS]: "#F44E4E"
}

const getChartConfig = function(props = {}) {
  const mergedProps = mergeProps(props, {
    seriesMetricsUids: [MetricUId.PENDING_PROGRAM_INVITATIONS, MetricUId.ACCEPTED_PROGRAM_INVITATIONS, MetricUId.EXPIRED_PROGRAM_INVITATIONS],
    subTitleMetricUid: MetricUId.PROGRAM_INVITATIONS_SENT,
    exportFileName: i18n.t("feature.program_invitations.header.invitations"),
    metricColorMap: metricColorMap
  });

  return getChartConfigTemplate(mergedProps);
};

export default getChartConfig;
